export const OPERATIONAL_STATUSES = ['active', 'building'] as const

export function isTenantOperational(status: string): boolean {
  return OPERATIONAL_STATUSES.includes(status as (typeof OPERATIONAL_STATUSES)[number])
}

const STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  building: 'Building',
  inactive: 'Inactive',
  validating: 'Validating',
  suspended: 'Suspended',
}

const STATUS_BADGE_CLASSES: Record<string, string> = {
  active: 'bg-green-100 text-green-700',
  building: 'bg-amber-100 text-amber-800',
  inactive: 'bg-gray-100 text-gray-500',
  validating: 'bg-blue-100 text-blue-700',
  suspended: 'bg-red-100 text-red-700',
}

export function getTenantStatusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status.charAt(0).toUpperCase() + status.slice(1)
}

export function getTenantStatusBadgeClass(status: string): string {
  return STATUS_BADGE_CLASSES[status] ?? 'bg-gray-100 text-gray-500'
}
